interface HistoryAccountShowProps {
  Title?: string;
  Amount?: number;
  AfterBetAmount?: number;
  Status?: string;
  DisplayCreatedAt?: string;
  StatusWinLost?: string;
  StatusWinLostColor?: string;
}

export default function HistoryBetGameShow(props: HistoryAccountShowProps) {
  return (
    <>
      <div>
        <div
          className="card-add"
          style={{
            paddingTop: 5,
            paddingBottom: 0,
          }}
        >
          <div className="font-card-add text-left">
            {props.DisplayCreatedAt}
          </div>
          <div className="font-card-add text-center">{props.Title}</div>
          <div className="font-card-add">
            <label>
              <div> {props.Amount?.format(2, 0)}</div>
            </label>
          </div>
          <div className="font-card-add">
            <label style={{ color: "#29c94d" }}>
              <div>{props.Status ? "สำเร็จ" : "กำลังรอ..."}</div>
            </label>
          </div>
          <div
            className="font-card-add text-right"
            style={{
              color: (props.AfterBetAmount ?? 0) > 0 ? "#29c94d" : "red",
              fontWeight: "bold",
            }}
          >
            {props.AfterBetAmount?.format(2, 0)}
            {(props.AfterBetAmount ?? 0) > 0 ? "+" : "-"}
          </div>
        </div>
      </div>
      {/*  <div>
        <div className="row">
          <div className="col-4">
            <div
              style={{
                color:
                  (props.StatusWinLostColor ?? "-") == "red" ? "red" : "green",
              }}
            >
              <h4>{props.StatusWinLost}</h4>
            </div>
          </div>
          <div className="col-8">
            <div
              style={{
                color: (props.AfterBetAmount ?? 0) <= 0 ? "red" : "green",
              }}
              className="text-right"
            >
              <h4>{props.AfterBetAmount?.format(2, 0)}</h4>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="row">
          <div className="col-6 margin-top-3">จำนวนเดิมพัน</div>
          <div className="text-right col-6">
            <h4>{props.Amount}</h4>
          </div>
          <div className="col-8 margin-top-3 font-bold">{props.Title}</div>
          <div className="text-right col-4 margin-top-3">{props.Status}</div>
          <div className="col-2">
            <div className="text-left"></div>
          </div>
          <div className="col-10">
            <div className="text-right">{props.DisplayCreatedAt}</div>
          </div>
        </div>
      </div>
      <div className="bottom-line-yellow"></div> */}
    </>
  );
}
